import React from 'react'
import EditForm from '../edit-form'
import Modal from '../../modals/wrapper'

const EditCourseModal = ({
    experienceId,
    saveAsNew,
    onClose = () => {}
}) => {

    return (
        <Modal
            fullWidth
            enforceFocus={false}
            backdrop='static'
            closeButton
            onHide={() => onClose()}
        >
            <div
                style={{
                    padding: '20px'
                }}
            >
                <EditForm experienceId={experienceId} onClose={onClose} saveAsNew={saveAsNew}/>
            </div>
        </Modal>
    )
}

export default EditCourseModal